import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin } from 'antd'
import QuestionnaireDetail from './detail'

export default function Questionnaire() {
  const [questionnaireData, setQuestionnaireData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [propsData, setPropsData] = useState({})
  const [isDetailQuestionnaireVisible, setIsDetailQuestionnaireVisible] = useState(false)

  const getQuestionnaireData = () => {
    axios.post('/admin/forms/questionnaire/record/list/get', { 
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setQuestionnaireData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'records': response.data.records
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getQuestionnaireData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const detailQuestionnaire = (oid) => {
    setIsDetailQuestionnaireVisible(true)
    setPropsData({ oid: oid })
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">筛查问卷</div>
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{textAlign: 'left', paddingLeft: '25px', paddingRight: '20px'}}>提交问卷</th>
                    <th>
                      <div className='public-main-style2-title'>提交用户</div>
                    </th>
                    <th>提交时间</th>
                  </tr>
                </thead>

                <tbody>
                  {questionnaireData.records && (questionnaireData.records.length > 0 ? (questionnaireData.records.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid}  onClick={() => { detailQuestionnaire(item.oid) }}>
                      <td style={{textAlign: 'left', paddingLeft: '20px', paddingRight: '20px'}}>{item.form_name}</td>
                      <td>
                        <div className='public-main-style2-tuwen'>
                          <img src={item.user_avatar_url} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.user_name}</span>
                        </div>
                      </td>
                      <td>{item.submission_time}</td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={questionnaireData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>
      </Spin>

      {isDetailQuestionnaireVisible && <QuestionnaireDetail
        data={propsData}
        isOpen={isDetailQuestionnaireVisible} 
        isCancel={() => { setIsDetailQuestionnaireVisible(false) }} 
      />}
    </div>
  )
}
